import { render, staticRenderFns } from "./MoveAssetModal.vue?vue&type=template&id=48173736&"
import script from "./MoveAssetModal.vue?vue&type=script&lang=js&"
export * from "./MoveAssetModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveAssetModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports